import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';

import AntibodyMapTabOptions from 'antibodies/antibody-map/AntibodyMapTabOptions';
import AntibodyMapTabState from 'antibodies/antibody-map/AntibodyMapTabState';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

export default class AntibodyMapTabOptionsView extends Backbone.View<AntibodyMapTabState> {
  render(): this {
    renderToDOM(
      <AntibodyMapTabOptions
        antibodyId={this.model.get('antibodyId')}
        isEditable={this.model.get('isEditable')}
      />,
      this.el
    );
    return this;
  }

  remove(): Backbone.View<AntibodyMapTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

AntibodyMapTabOptionsView.prototype.className = 'reset';
AntibodyMapTabOptionsView.prototype.tagName = 'div';
